import React, {useState, useEffect} from 'react'
import WCMImage from './sfc/wcmimage'
import SafeLink from './sfc/safelink'

let athlete_list = require('../data/athletes.sheet.json')
if(athlete_list[0].Name.includes("full name")){
    athlete_list.shift()
}
// If "winner" property is missing, set it to false
athlete_list = athlete_list.map(d => {
    d["winner"] = (d.winner == null) ? "FALSE" : d.winner;
    return d;
});
athlete_list = athlete_list.filter(i => i.Page_Date.length != 0)

const HubPageCard = ({name, slug, date_readable, hideDate, pageDate, voting_closed, winner_announced}) => {
    const [pageWinner, setPageWinner] = useState(null);
   
        useEffect(() => {
            if (voting_closed && winner_announced == 'TRUE') {
                
                let filteredList = athlete_list.filter(i => i.Page_Date === pageDate)
                let winners = filteredList.filter(i => i.winner == 'TRUE')
  
                let winner;
                if(winners.length > 1){
                    let winnerArray = []
                    for(let w of winners){
                        winnerArray.push(w.Name)
                    }
                    let winnerString = winnerArray.join(' and ')
                    setPageWinner(winnerString)
                } else {
                    winner = filteredList.find(i => i.winner == 'TRUE')
                    if (winner !== undefined) {
                        setPageWinner(winner.Name)
                    } else {
                        console.error(
                            `WARNING! According to "page_settings", this page should have a winner announced` + 
                            `but a winner has not been selected in "athletes"!` + 
                            `\n pageDate: ${pageDate}` +
                            `\n athletes: ${filteredList.map(i => i.Name).join(", ")}`
                            )
                    }
                }
            }
        })
    
    return(
        <SafeLink href={'/' + slug} withinProject={true}>
        <div className='aotw-hubpage-link'>
            <h2>{name}</h2>
            {!hideDate && <h3>{date_readable}</h3>}
            {!voting_closed && <p className='hubpage-voting-status'>Voting is open</p>}
            {voting_closed && pageWinner == null && <p className='hubpage-voting-status'>Voting is closed.</p>}
            {voting_closed && pageWinner !== null && <p className='hubpage-voting-status'>Winner: {pageWinner}</p>}
        </div>
        </SafeLink>

    )
}
export default HubPageCard